import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function MedicamentosPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>
      <Header header={'Medicamentos'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'TabelaGeral'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Tabela Geral'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'TabelaCategorias'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Tabela de Categorias'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'TabelaSolicitações'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Tabela de Solicitações'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'gerenciarEstadoMedicamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gerenciar Estado do Medicamento'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'reclamacoesMedicamentos'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestao de Reclamações de Registo de Medicamentos'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />
    </>
  )
}
